import React, { useContext, useEffect, useState } from 'react'
import {ContextGloball} from '../Context/ContextGlobal';
import MsgUtils from '../Tools/MsgUtils';
const server = process.env.REACT_APP_SERVER;

function SettingCredenciales(props) {
    const { regional } = props;
    const { loading, setLoading,setVentana } = useContext(ContextGloball);
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [cambiar, setCambiar] = useState(false);
    function getInfoUser(info) {
        fetch(`${server}/usuario/getUserCredential`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'idEmpleado': info.ID_EMPLEADO, 'regional': info.ID_REGIONAL_ACTUAL
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setPassword(data.ok.CLAVE_USUARIO);
                    setUserName(data.ok.NOMBRE_USUARIO);
                } else {
                    MsgUtils.msgError(data.error)
                }
                setLoading(false);
            })
            .catch(err => MsgUtils.msgError(err));
    }
    function EditarGuardar() {
        if (cambiar) {
            if(userName!==''&&password!==''){
                setLoading(true);
                var info = JSON.parse(localStorage.getItem('info'));
                fetch(`${server}/usuario/setUserCredential`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        'idEmpleado': info.ID_EMPLEADO, 'regional': info.ID_REGIONAL_ACTUAL,userName,password
                    })
                })
                    .then(res => res.json())
                    .then(data => {
                        if (data.ok) {
                            setCambiar(false);
                            setVentana('0');
                            MsgUtils.msgCorrecto(data.ok);
                        } else {
                            MsgUtils.msgError(data.error);
                        }
                        setLoading(false);
                    })
                    .catch(err => MsgUtils.msgError(err));
            }else{
                MsgUtils.msgError("Colocal Usuario y contraseña por favor...")
            }
        } else {
            setCambiar(!cambiar);
        }
    }
    useEffect(() => {
        var info = JSON.parse(localStorage.getItem('info'));
        if (userName === '' && password === '') {
            setLoading(true);
            getInfoUser(info);
        }
    }, [])
    return (
        <div className='container-fluid d-flex justify-content-center align-self-center py-4'>
            <div className='card bg-dark bg-gradient' style={{ width: '30rem' }}>
                <div className='card-header m-0 p-0'>
                    <div className='row row-cols-2 g-0'>
                        <div className='col-2'>
                            <button className='btn btn-sm text-danger fs-2 m-0 p-0' onClick={()=>setVentana('0')}>
                                <i className="fa-solid fa-circle-xmark"></i>
                            </button>
                        </div>
                        <div className='col-10 my-auto'>
                            <div className='text-light text-center'>
                                Cambiar Credenciales
                            </div>
                        </div>
                    </div>
                </div>
                <div className='card-body m-0 p-0'>
                    <div className='container-fluid'>
                        <div className="mb-3">
                            <label className="form-label text-light">Nombre Usuario</label>
                            <input type="text" className="form-control" value={userName}
                                placeholder='Nombre Usuario' disabled={!cambiar} onChange={(e)=>setUserName(e.target.value)}/>
                        </div>
                        <div className="mb-3">
                            <label className="form-label text-light">Contraseña</label>
                            <input type="password" className="form-control" value={password}
                                placeholder='contraseña' disabled={!cambiar} onChange={(e)=>setPassword(e.target.value)}/>
                        </div>
                    </div>
                </div>
                <div className='card-footer text-center'>
                    <button className={`btn btn-sm ${cambiar ? 'btn-success' : 'btn-secondary'} bg-gradient`} onClick={() => EditarGuardar()}>
                        {cambiar ? 'GUARDAR' : 'EDITAR'}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default SettingCredenciales
